<!--填空 SBQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{ `${index + 1}、` }}</span>
          </div>
          <div class="question-select">
            <span>填空</span>
          </div>
          <div class="question-text">
            <div class="add-batch" @click="handleAnswerAndScore">
              答案与分值
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="textareaFocus"
          @blur="textareaBlur"
          rows="2"
          style="width: 100%; resize: none"
          ref="introTextarea"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, idx) in images"
          :key="idx"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(idx)"
          />
        </div>
      </div>
      <div class="add-view">
        <div class="required">
          <el-checkbox v-model="isMust" @change="handleUpdate">
            必选题
          </el-checkbox>
        </div>
        <div @click="addFillSymbol" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 12px; height: 12px"
          />
          <span>插入填空符</span>
        </div>
        <div class="add-batch" style="color: #ffffff">答案与分值</div>
      </div>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <!-- <uploadImage
      :show="showUpload"
      :maxCount="1"
      :images="0"
      @upload-close="showUpload = false"
      @upload-success="handleUploadComplete"
    /> -->
    <ExamAnswerSetting
      :show="showSetting"
      @close="showSetting = false"
      :dataObj="settingObj"
      @confirm="handleSettingChange"
    />
    <PopupPrompt
      :show="showPrompt"
      @close="showPrompt = false"
      :title="promptTitle"
      :content="promptContent"
      :cancel="promptCancel"
      :confirm="promptConfirm"
      @cancel="showPrompt = false"
      @confirm="handlePromptConfirm"
    />

    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import ExamAnswerSetting from "@/components/ExamAnswerSetting/ExamAnswerSetting.vue";
export default {
  name: "ExamEditSBQ",
  components: {
    // uploadImage: () => import("@/components/uploadImage/uploadImage.vue"),
    ExamAnswerSetting,
    // PopupPrompt: () => import("@/components/PopupPrompt/PopupPrompt.vue"),
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
  },
  data() {
    return {
      ifRandomize: false,
      isMust: false,
      images: [],
      showUpload: false,
      caseProblem: "",
      cursor: 0,
      isFocusIndex: "",
      showSetting: false,
      settingObj: {},
      oldFillSymbol: 0,
      showPrompt: false,
      promptType: "",
      promptTitle: "",
      promptContent: "",
      promptConfirm: "确定",
      promptCancel: "取消",
      questionScore: 0,
      chooseAnswer: "",
      explanation: "",
      scoringMethod: 0,
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (!newValue || Object.keys(newValue).length === 0) return;
        console.log("ot0to05ot0to054ot045ot045");
        this.dataObj = newValue;
        this.oldFillSymbol = newValue.caseProblem.split("____").length - 1;
        this.caseProblem = newValue.caseProblem;
        this.ifRandomize = newValue.ifRandomize === 1;
        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg);
        this.questionScore = newValue.questionScore;
        this.chooseAnswer = newValue.chooseAnswer;
        this.explanation = newValue.analysis;
        this.scoringMethod = newValue.scoringMethod;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    // textareaBlur(e) {
    //   console.log(e);

    //   this.cursor = e.detail ? e.detail.cursor : 0;
    // },
    textareaFocus() {
      this.isFocusIndex = "-1";
      const textarea = this.$refs.introTextarea;
      this.cursor = textarea.selectionStart;
    },
    textareaBlur(e) {
      this.isFocusIndex = "";
      const textarea = this.$refs.introTextarea;
      this.cursor = textarea.selectionStart;
      console.log("this.cursor", this.cursor);
    },
    addFillSymbol() {
      // setTimeout(() => {
      //   const newText =
      //     this.caseProblem.slice(0, this.cursor) +
      //     "____" +
      //     this.caseProblem.slice(this.cursor);
      //   this.caseProblem = newText;
      //   const fillSymbolCount = this.caseProblem.split("____").length - 1;
      //   this.chooseAnswer = this.chooseAnswer
      //     .split(";")
      //     .slice(0, fillSymbolCount)
      //     .join(";");
      //   this.updateData();
      // }, 100);
      setTimeout(() => {
        const newText =
          this.caseProblem.slice(0, this.cursor) +
          "____" +
          this.caseProblem.slice(this.cursor);
        this.caseProblem = newText;
        const fillSymbolCount = this.caseProblem.split("____").length - 1;
        this.chooseAnswer = this.chooseAnswer
          .split(";")
          .slice(0, fillSymbolCount)
          .join(";");
        this.dataObj.isMust = this.isMust ? 1 : 0;
        this.dataObj.ifRandomize = this.ifRandomize ? 1 : 0;
        this.dataObj.caseProblemImg = JSON.stringify(this.images);
        this.dataObj.caseProblem =
          this.caseProblem === "" ? "请填写本项内容" : this.caseProblem;
        this.dataObj.questionScore = this.questionScore;
        this.dataObj.chooseAnswer = this.chooseAnswer;
        this.dataObj.analysis = this.explanation;
        this.dataObj.scoringMethod = this.scoringMethod;
        this.$emit(
          "update",
          JSON.stringify({
            index: this.index,
            data: this.dataObj,
          }),
        );
      }, 100);
    },
    handleCaseProblemImg() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          this.images = [response.data.urls];
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    handleUploadComplete(images) {
      this.images = images;
      this.handleUpdate();
    },
    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    handleAnswerAndScore() {
      this.settingObj = {
        ...this.dataObj,
        caseProblem: this.caseProblem,
        questionScore: this.questionScore,
        explanation: this.explanation,
        scoringMethod: this.scoringMethod,
        chooseAnswer: this.chooseAnswer,
      };
      console.log("settingObj", this.settingObj);
      this.showSetting = true;
    },
    handleSettingChange(e) {
      console.log("e", e);
      this.questionScore = JSON.parse(e).questionScore;
      this.explanation = JSON.parse(e).explanation;
      this.scoringMethod = JSON.parse(e).scoringMethod;
      this.chooseAnswer = JSON.parse(JSON.parse(e).chooseList)
        .list.map((item) => item.correct_answer)
        .join(";");
      console.log("叫哦日计划哦人家好哦溶剂后", this.scoringMethod);
      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      this.chooseAnswer = this.chooseAnswer
        .split(";")
        .slice(0, fillSymbolCount)
        .join(";");
      this.updateData();
      this.showSetting = false;
    },
    saveClick() {
      this.saveData();
    },
    handlePromptConfirm() {
      this.showPrompt = false;
      this.saveData();
    },
    saveData() {
      if (this.caseProblem.trim() === "" && this.caseProblem.includes(" ")) {
        this.$message.error("请输入题目");
        return;
      }
      if (!this.caseProblem.trim().includes("____")) {
        this.$message.error("请插入填空符");
        return;
      }
      if (
        this.chooseAnswer.split(";").length <
        this.caseProblem.split("____").length - 1
      ) {
        this.$message.error("请输入答案");
        return;
      }
      const isCorrect = this.chooseAnswer
        .split(";")
        .some((item) => item.trim() === "");
      if (isCorrect) {
        this.$message.error("请输入答案");
        return;
      }
      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      this.chooseAnswer = this.chooseAnswer
        .split(";")
        .slice(0, fillSymbolCount)
        .join(";");
      this.updateData();
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.getDataObj(),
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.getDataObj(),
        }),
      );
    },
    handleUpdate() {
      const fillSymbolCount = this.caseProblem.split("____").length - 1;
      this.chooseAnswer = this.chooseAnswer
        .split(";")
        .slice(0, fillSymbolCount)
        .join(";");
      this.updateData();
    },
    updateData() {
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.getDataObj(),
        }),
      );
    },
    getDataObj() {
      return {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem:
          this.caseProblem === "" ? "请填写本项内容" : this.caseProblem,
        questionScore: this.questionScore,
        chooseAnswer: this.chooseAnswer,
        analysis: this.explanation,
        scoringMethod: this.scoringMethod,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  margin-left: 10px;
}

.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 2px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 5px;
  cursor: pointer;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.add-btn {
  width: 153px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #00c755;
    margin-left: 11px;
  }
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.del1 {
  width: 19px;
  height: 19px;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item {
  width: 100%;
  background: #f8f8f8;
  border: 1px dashed #3a60ff;
  border-radius: 4px;
  padding: 15px 12px;
  box-sizing: border-box;
  margin-top: 10px;
}

.rating {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.rating-item {
  width: 100px;
  height: 33px;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 3px;
  display: flex;
  align-items: center;

  input {
    flex-grow: 1;
    height: 100%;
    border: none;
    padding: 5px;
    box-sizing: border-box;
    font-size: 14px;
  }
}

.question-header-right {
  display: flex;
  align-items: center;

  .add-batch {
    border-bottom: 1px solid #509dee;
  }
}

.asterisk {
  color: red;
  margin-right: 4px;
}

.textarea-box {
  ::v-deep .el-textarea__inner {
    color: #4c4a56;
    border: none;
    padding: 0;
    background: transparent;
  }
}

.question-header-left {
  display: flex;
  align-items: center;

  .question-select {
    margin-left: 10px;
    padding: 4px 12px;
    background: #f0f0f0;
    border-radius: 4px;
    font-size: 14px;
  }
}

.case-problem-textarea {
  width: 100%;
}

.question-number {
  font-weight: 600;
  font-size: 16px;
}

.question-text {
  display: flex;
  align-items: center;
  margin-left: 10px;

  .add-batch {
    border-bottom: 2px solid #509dee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExamEdit/ExamEditSBQ.vue